import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const externalGameTypesSlice = createSlice({
  name: 'externalGameTypes',
  initialState,
  reducers: {
    set(_, action) {
      return action.payload;
    },
  },
});

export const externalGameTypes = externalGameTypesSlice.actions;
export default externalGameTypesSlice.reducer;
